import {forwardRef} from "react";
import classes from "./form-elements.module.css";

interface FormLabelProps {
    value: string;
    active?: boolean;
    children?: React.ReactNode;
    className?: string;
    htmlFor?: string;
}

export const FormLabel = forwardRef<HTMLLabelElement, FormLabelProps>(
    ({value, active, children, className, htmlFor}, ref) => (
        <label
            ref={ref}
            htmlFor={htmlFor}
            className={`${classes.labelContainer}${className ? ` ${className}` : ""}`}
        >
            <span
                className={`${classes.labelText}${active ? ` ${classes.active}` : ""}`}
            >
                {value}
            </span>
            {children}
        </label>
    )
);

FormLabel.displayName = "FormLabel";
